const getCSVData = data => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  // Define the CSV headers based on the actual API response structure
  const headers = [
    'Checks Paid From Date',
    'Checks Paid To Date',
    'W Proj Project Number',
    'W Proj Project Full Name',
    'W SubProj Number',
    'W SubProj Name',
    'Client Number',
    'Client Name',
    'Job Order Number',
    'W Corp RM Policy Number',
    'W Proj General Contractor Name',
    'W Corp RM Enrollment Contract Number',
    'W Corp RM Wrapup Number',
    'First Date Paid',
    'Last Date Paid',
    'Job Site State',
    'W Proj Coverage Type',
    'Comp Code',
    'Workers Comp Description',
    'GL Classification Description',
    'GL Code',
    'Regular Hours',
    'Overtime Hours',
    'Doubletime Hours',
    'Total Hours Worked',
    'Regular Wages',
    'Overtime Wages',
    'Doubletime Wages',
    'Total Gross Wages',
    'Total Straight Wages',
    'Total Receipts',
    'Cumulative Project Hours',
    'Cumulative Project WRAP Payroll',
    'Cumulative Project Receipts',
  ];

  // Convert data to CSV format
  const csvData = data.map(item => [
    item.FromPayrollCalcDate || '',
    item.ToPayrollCalcDate || '',
    item.WProjNumber || '',
    item.WProjFullName || '',
    item.WSubProjNumber || '',
    item.WSubProjName || '',
    item.CustId || '',
    item.CustName || '',
    item.JobOrderNumber || '',
    item.WCorpRMPolicyNbr || '',
    item.WProjGeneralContractorName || '',
    item.WCorpRMEnrollmentContractNbr || '',
    item.WCorpRMWrapupNbr || '',
    item.FirstDatePaid || '',
    item.LastDatePaid || '',
    item.JobSiteState || '',
    item.WProjCoverageType || '',
    item.CompCode || '',
    item.WorkersCompDescription || '',
    item.GLClassificationDescription || '',
    item.GLCode || '',
    item.RegularHours || 0,
    item.OvertimeHours || 0,
    item.DoubletimeHours || 0,
    item.TotalHoursWorked || 0,
    item.RegularWages || 0,
    item.OvertimeWages || 0,
    item.DoubletimeWages || 0,
    item.TotalGrossWages || 0,
    item.TotalStraightWages || 0,
    item.TotalReceipts || 0,
    item.CumulativeProjectHours || 0,
    item.CumulativeProjectWRAPPayroll || 0,
    item.CumulativeProjectReceipts || 0,
  ]);

  return [headers, ...csvData];
};

export default getCSVData;
